import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { URL, colors } from "../../../utils/constant";
import { useEffect } from "react";
import useHypoglycemiaList from "../../../data/talons/Hypoglycemia/useHypoglycemiaList";
import { get } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  getBloodSugarUpdate,
  getPageId,
  getPageStatusData,
} from "../../../data/selector/component.selector";
import { getHypoglycemia } from "../../../data/selector/hypoglycemia.selector";
import { Box, Button, FormLabel, Grid, Stack, Typography } from "@mui/material";
import MuiDate from "../../../component/shared/MUIDatePicker";
import { useState } from "react";
import { getUserToken } from "../../../data/selector/appState.selector";
import { useAuth } from "../../../data/talons/auth/useAuth";
import usePatientDetails from "../../../data/talons/PatientDetails/usePatientDetails";
import usePageStatus from "../../../data/talons/PageStatus/usePageStatus";
import { getSelectedVisit } from "../../../data/selector/visits.selector";
import { useNavigate } from "react-router-dom";
import {
  getLanguage,
  getLanguageNumber,
} from "../../../data/selector/language.selector";
import { differenceInDays, parse } from "date-fns";
import { setDayCount } from "../../../data/reducer/visits.reducer";
import dayjs from "dayjs";
import {
  setPageId,
  setSelectedRecordDate,
} from "../../../data/reducer/component.reducer";
import Dialogue from "../../../component/shared/Dialogue";
import EditIcon from "@mui/icons-material/Edit";
import { setSelectedList } from "../../../data/reducer/bloodSugarRecord.reducer";
import { setHypoFlag } from "../../../data/reducer/hypoglycemia.reducer";
import { setSelectedLanguage } from "../../../data/reducer/language.reducer";
import { English } from "../../../Languages/en";
import { Spanish } from "../../../Languages/sp";
import { useHypoglycemia } from "../../../data/talons/Hypoglycemia/useHypoglycemia";

function createData(
  record,
  HYPO_DATE,
  HYPO_TIME,
  BS_VALUE,
  HYPO_SYM,
  HYPO_SYMother,
  HYPO_REACT,
  HYPO_TREAT
) {
  //   const density = population / size;
  return {
    record,
    HYPO_DATE,
    HYPO_TIME,
    BS_VALUE,
    HYPO_SYM,
    HYPO_SYMother,
    HYPO_REACT,
    HYPO_TREAT,
  };
}

const HypoglycemiaList = ({ flag }) => {
  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);
  const columns = [
    // { id: "record", label: "Record Number", minWidth: 170, align: "right" },
    {
      id: "HYPO_DATE",
      label: Language.HypoglycemiaTitles?.Date,
      minWidth: 100,
    },
    {
      id: "HYPO_TIME",
      label: Language.HypoglycemiaTitles?.Time,
      minWidth: 100,
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "BS_VALUE",
      label: Language.HypoglycemiaTitles?.Blood_sugar_value,
      minWidth: 50,
      align: "right",
    },
    {
      id: "HYPO_SYM",
      label: Language.HypoglycemiaTitles?.sym,
      minWidth: 350,
    },
    {
      id: "HYPO_SYMother",
      label: Language.HypoglycemiaTitles?.symOther,
      minWidth: 300,
    },
    {
      id: "HYPO_REACT",
      label: Language.HypoglycemiaTitles?.reaction,
      minWidth: 350,
    },
    {
      id: "HYPO_TREAT",
      label: Language.HypoglycemiaTitles?.treatment,
      minWidth: 400,
    },
  ];
  const action = [
    {
      id: "Actions",
      label: Language.BloodSugarRecords?.action,
      minWidth: 100,
      align: "left",
    },
  ];
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { fetchRecordsList } = useHypoglycemiaList();
  const { handleChnagedLanguageList, handleReaction } = useHypoglycemia();
  const pageStatusObj = useSelector(getPageId);
  const pageId = get(pageStatusObj.pageData, "PageId", "");
  const listData = useSelector(getHypoglycemia);
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset page to 0 when rows per page changes
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: colors.blue,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  useEffect(() => {
    fetchRecordsList(pageId);
  }, [pageId, flag]);

  const { fetchPageStatus } = usePageStatus();
  const selectedVisitId = useSelector(getSelectedVisit);
  const startDate = selectedVisitId.VisitStartDate;
  const visitId = selectedVisitId?.VisitId;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Open, setOpen] = useState(false);
  const [Alert, setAlert] = useState("");

  const bloodSugarSelector = useSelector(getBloodSugarUpdate);
  const pageStatusApiData = useSelector(getPageStatusData);

  useEffect(() => {
    if (bloodSugarSelector?.recordNo === 8) {
      const pageStatusobj = {
        pageData: pageStatusApiData[pageStatusApiData?.length - 1],
      };
      dispatch(setPageId(pageStatusobj));
    }
  }, [bloodSugarSelector]);

  useEffect(() => {
    fetchPageStatus();
  }, [visitId]);

  useEffect(() => {
    if (!number) {
      dispatch(setSelectedLanguage(English));
    } else if (number == 1) {
      dispatch(setSelectedLanguage(English));
    } else if (number == 2) {
      dispatch(setSelectedLanguage(Spanish));
    }
  }, [number]);

  useEffect(() => {
    let differenceDate = differenceInDays(
      new Date(),
      parse(startDate, "dd/MMM/yyyy", new Date())
    );
    dispatch(setDayCount(differenceDate));
  }, []);

  return (
    <Paper
      sx={{
        height: "fit-content",
        marginLeft: "408px",
        overflow: "hidden",
        mt: 9,
        mr: 2.5,
      }}
    >
      <Dialogue open={Open} setOpen={setOpen} Alert={Alert} />
      <Box className="d-flex justify-content-between pt-4 ps-2">
        <Stack>
          {/* <Typography variant="h4" className="fw-bold">
            {selectedVisitId?.VisitName}
          </Typography> */}
        </Stack>
        <Box
          className="d-flex align-items-center gap-3"
          sx={{
            width: "fit-content",
          }}
        >
          <Button
            onClick={() => {
              dispatch(setSelectedList(null));
              dispatch(setHypoFlag(false));
              navigate(URL.form);
            }}
            variant="contained"
            className="fw-bold"
            style={{
              marginRight: 15,
              borderRadius: 0,
              backgroundColor: colors.blue,
              color: "white",
              lineHeight: 2.5,
              // width: 100,
              border: "none",
              fontSize: 12,
            }}
          >
            {Language.ButtonText.Add_New_Entry}
          </Button>
        </Box>
      </Box>
      <TableContainer sx={{ maxHeight: 440, mt: 4 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {action?.map((column) => (
                <StyledTableCell
                  key={column?.id}
                  align={"left"}
                  style={{
                    minWidth: column?.minWidth,
                    fontWeight: 800,
                  }}
                >
                  {column?.label}
                </StyledTableCell>
              ))}
              {columns?.map((column) => (
                <StyledTableCell
                  key={column?.id}
                  align={"left"}
                  style={{ minWidth: column?.minWidth, fontWeight: 800 }}
                >
                  {column?.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {listData?.length > 0 ? (
              listData?.slice(startIndex, endIndex).map((row, index) => (
                <TableRow key={index} hover>
                  <TableCell
                    onClick={() => {
                      dispatch(setSelectedList(row));
                      dispatch(setHypoFlag(true));
                      navigate(URL.form);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <EditIcon />
                  </TableCell>
                  {columns?.map((column) => (
                    <TableCell key={column?.id} align={"left"}>
                      {column?.id === "HYPO_SYM"
                        ? handleChnagedLanguageList(
                            row,
                            column,
                            Language.HypoglycemiaTitles.Symptoms_Options
                          )
                        : column?.id === "HYPO_TREAT"
                        ? handleChnagedLanguageList(
                            row,
                            column,
                            Language.HypoglycemiaTitles.Treatment_options
                          )
                        : column?.id === "HYPO_REACT"
                        ? handleReaction(
                            row,
                            column,
                            Language.HypoglycemiaTitles
                              .Reaction_Recognized_By_Options
                          )
                        : get(
                            row?.ItemList.find(
                              (item) => item?.ItemId === column?.id
                            ),
                            "ItemValue",
                            ""
                          ).replace(/¥/g, ", ")}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns?.length} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]} // Define your rows per page options
        component="div"
        count={listData?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default HypoglycemiaList;
